var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Truck50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M43,36H29V14h10.559c0.86,0,1.625,0.551,1.897,1.368L45,26v8C45,35.105,44.105,36,43,36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    d: "M29,36H5c-1.105,0-2-0.895-2-2V9c0-1.105,0.895-2,2-2h22c1.105,0,2,0.895,2,2V36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D4037",
    d: "M42 36c0 2.761-2.238 5-5 5s-5-2.239-5-5 2.238-5 5-5S42 33.239 42 36M18 36c0 2.761-2.239 5-5 5s-5-2.239-5-5 2.239-5 5-5S18 33.239 18 36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCAAA4",
    d: "M39 36c0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2S39 34.895 39 36M15 36c0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2S15 34.895 15 36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M41,25h-7c-0.552,0-1-0.448-1-1v-7c0-0.552,0.448-1,1-1h5c0.432,0,0.813,0.275,0.949,0.684l2,6C41.982,22.786,42,22.893,42,23v1C42,24.552,41.552,25,41,25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DB6AC",
    d: "M3 17H29V25H3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Truck50);
export default __webpack_public_path__ + "static/media/icons8-truck-50.16a6884ad8e68e5f0002db396b529a9b.svg";
export { ForwardRef as ReactComponent };